/* Storefront estimates only. Shopify remains authoritative in cart and checkout. */
(() => {
  const localOffers = [...document.querySelectorAll('[data-display-discount]')].some(node => Number(node.dataset.displayDiscount) > 0);
  if (!window.NiralaRemoteDiscountsEnabled && !localOffers && !window.Shopify?.designMode) return;
  let offers = new Map();
  let loaded = true;
  let lastRefresh = 0;
  const variantCache = new WeakMap();
  const cardStates = new WeakMap();
  function readVariants(root, selector) {
    const node = root.querySelector(selector);
    if (!node) return [];
    const text = node.textContent;
    const cached = variantCache.get(node);
    if (cached?.text === text) return cached.value;
    try {
      const value = JSON.parse(text || '[]');
      if (!Array.isArray(value)) return [];
      variantCache.set(node, { text, value });
      return value;
    } catch (_) { return []; }
  }
  const money = cents => window.Nirala?.formatMoney?.(cents) || `Rs. ${(cents / 100).toFixed(2)}`;
  const original = node => {
    if (node && !node.hasAttribute('data-live-original')) node.dataset.liveOriginal = node.textContent;
  };
  const restore = node => {
    if (node?.hasAttribute('data-live-original')) {
      node.textContent = node.dataset.liveOriginal;
      delete node.dataset.liveOriginal;
    }
  };
  function offerFor(id, root) {
    const remote = offers.get(String(id || '').split('/').pop());
    if (remote) return remote;
    const percentage = Number(root?.dataset.displayDiscount);
    const until = Date.parse(root?.dataset.displayDiscountUntil || '');
    const from = root?.dataset.displayDiscountFrom ? Date.parse(root.dataset.displayDiscountFrom) : 0;
    // Explicit per-product display configuration; never infer an admin discount.
    if (percentage > 0 && percentage < 100 && Number.isFinite(until) && Number.isFinite(from) && Date.now() >= from && Date.now() < until)
      return { percentage, showBadge: true };
    return null;
  }
  function setBadge(node, offer) {
    if (!node) return;
    if (offer?.showBadge === false || !offer) {
      if (node.hasAttribute('data-live-badge')) node.remove();
      else if (node.hasAttribute('data-live-hidden')) { node.hidden = true; delete node.dataset.liveHidden; }
      return;
    }
    node.hidden = false;
    node.textContent = `${offer.percentage}% OFF`;
  }
  function cards() {
    // Shared renderer for every standard product card.
    document.querySelectorAll('[data-menu-card]:not([data-discount-deals-card])').forEach(card => {
      // One renderer owns card prices across home, collection and search.
      const offer = offerFor(card.dataset.productId, card);
      const signature = JSON.stringify([offer?.percentage, offer?.showBadge, card.dataset.productPrice]);
      if (cardStates.get(card) === signature) return;
      cardStates.set(card, signature);
      card.toggleAttribute('data-display-offer-active', Boolean(offer && offer.showBadge !== false));
      const image = card.querySelector('.np-product-card__image');
      const price = card.querySelector('.np-product-card__price');
      const value = price?.querySelector('strong');
      const badge = image?.querySelector('[data-live-badge]');
      const compare = price?.querySelector('[data-live-compare]');
      if (!offer || offer.showBadge === false) {
        badge?.remove(); compare?.remove(); restore(value);
        price?.querySelectorAll('s:not([data-live-compare])').forEach(node => { node.hidden = false; });
        return;
      }
      const cents = Number(card.dataset.productPrice);
      if (!image || !price || !value || !(cents > 0)) return;
      const newBadge = badge || document.createElement('span');
      newBadge.className = 'np-live-discount';
      newBadge.dataset.liveBadge = '';
      setBadge(newBadge, offer);
      if (!badge) image.append(newBadge);
      original(value);
      value.textContent = money(Math.round(cents * (100 - offer.percentage) / 100));
      price.querySelectorAll('s:not([data-live-compare])').forEach(node => { node.hidden = true; });
      const old = compare || document.createElement('s');
      old.dataset.liveCompare = '';
      old.textContent = money(cents);
      if (!compare) price.append(old);
    });
  }
  function product(section) {
    const offer = offerFor(section.dataset.productId, section);
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-product-compare]');
    const badge = section.querySelector('[data-product-sale-badge]');
    const addedCompare = section.querySelector('[data-live-product-compare]');
    if (!price) return;
    const variants = readVariants(section, '[data-product-variants]');
    const form = section.querySelector('[data-product-form]');
    const id = form?.elements.namedItem('id')?.value || section.dataset.displayVariant;
    const selected = variants.find(v => String(v.id) === id);
    if (!selected) return;
    const extras = Math.max(0, Number(window.NiralaProductAddons?.getUnitTotal?.(form)) || 0);
    if (!offer || offer.showBadge === false) {
      restore(price); price.textContent = money(Number(selected.priceAmount) + extras); addedCompare?.remove();
      if (compare) { compare.hidden = !selected?.compare; compare.textContent = selected?.compare || ''; }
      if (badge) { badge.hidden = !selected?.saleBadgeText; badge.textContent = selected?.saleBadgeText || ''; }
      return;
    }
    const cents = Number(selected?.priceAmount);
    if (!(cents > 0)) return;
    original(price);
    price.textContent = money(Math.round(cents * (100 - offer.percentage) / 100) + extras);
    if (compare) {
      compare.hidden = false;
      compare.textContent = money(cents);
    } else {
      const old = addedCompare || document.createElement('s');
      old.dataset.liveProductCompare = '';
      old.textContent = money(cents);
      if (!addedCompare) price.after(old);
    }
    if (badge) { badge.hidden = false; badge.textContent = `${offer.percentage}% OFF`; badge.dataset.liveHidden = ''; }
  }
  function popup() {
    const root = document.querySelector('[data-quick-order-dialog] [data-quick-order-product]');
    if (!root) return;
    const offer = offerFor(root.dataset.productId, root);
    const price = root.querySelector('[data-quick-price]');
    const compare = root.querySelector('[data-quick-compare]');
    const badge = root.querySelector('[data-quick-sale-badge]');
    const total = root.querySelector('[data-quick-total]');
    const variants = readVariants(root, '[data-quick-order-variants]');
    const id = root.querySelector('[data-quick-order-form] [name="id"]')?.value;
    const selections = [...root.querySelectorAll('[data-quick-option-index]')].map(group => group.querySelector(':checked')?.value);
    const selected = variants.find(v => String(v.id) === id) || variants.filter(v => v.available && selections.every((value, index) => value === undefined || v.options[index] === value)).reduce((best, v) => !best || v.price < best.price ? v : best, null);
    if (!selected) return;
    const unitExtras = Math.max(0, Number(window.NiralaProductAddons?.getUnitTotal?.(root.querySelector('[data-quick-order-form]'))) || 0);
    if (!offer || offer.showBadge === false) {
      if (price) { price.textContent = `${id ? '' : 'From '}${money(Number(selected.price) + unitExtras)}`; delete price.dataset.liveOriginal; }
      const sale = Boolean(id && selected.compareAtPrice > selected.price);
      if (compare) { compare.hidden = !sale || root.dataset.showCompare === 'false'; compare.textContent = sale ? selected.compareAtPriceText : ''; }
      if (badge) { badge.hidden = !sale || root.dataset.showSaleBadge === 'false'; badge.textContent = sale ? selected.saleBadgeText : ''; }
      if (total) {
        const input = root.querySelector('[data-quick-quantity]');
        const quantity = Number(input?.value);
        total.textContent = id && input?.checkValidity() && Number.isSafeInteger(quantity) && quantity > 0 ? money((Number(selected.price) + unitExtras) * quantity) : '—';
        delete total.dataset.liveOriginal;
      }
      return;
    }
    const cents = Number(selected?.price);
    if (!(cents > 0) || !price) return;
    original(price);
    price.textContent = `${id ? '' : 'From '}${money(Math.round(cents * (100 - offer.percentage) / 100) + unitExtras)}`;
    if (compare) { compare.hidden = false; compare.textContent = money(cents); }
    if (badge) { badge.hidden = false; badge.textContent = `${offer.percentage}% OFF`; }
    if (total) total.textContent = '—';
    if (id && total && root.querySelector('[data-quick-quantity]')?.checkValidity()) {
      const qty = Math.max(1, Number(root.querySelector('[data-quick-quantity]')?.value) || 1);
      const extras = Math.max(0, Number(window.NiralaProductAddons?.getUnitTotal?.(root.querySelector('[data-quick-order-form]'))) || 0);
      original(total);
      total.textContent = money((Math.round(cents * (100 - offer.percentage) / 100) + extras) * qty);
    }
  }
  // Local product interactions cannot change menu-card prices. Coalesce the
  // topping change and its follow-up variant event into one scoped update.
  const pendingProducts = new Set();
  let pendingPopup = false;
  let localRenderQueued = false;
  function queueLocalRender(section, updatePopup = false) {
    if (section) pendingProducts.add(section);
    pendingPopup = pendingPopup || updatePopup;
    if (localRenderQueued) return;
    localRenderQueued = true;
    queueMicrotask(() => {
      localRenderQueued = false;
      if (loaded) {
        pendingProducts.forEach(section => { if (section.isConnected) product(section); });
        if (pendingPopup) popup();
      }
      pendingProducts.clear();
      pendingPopup = false;
    });
  }
  document.addEventListener('nirala:addons-changed', event => {
    const form = event.detail?.form || event.target;
    const section = form.closest?.('[data-product-section][data-product-id]');
    const inPopup = Boolean(form.closest?.('[data-quick-order-product]'));
    if (section || inPopup) queueLocalRender(section, inPopup);
  });
  function render() {
    if (!loaded) return;
    cards();
    document.querySelectorAll('[data-product-section][data-product-id]').forEach(product);
    popup();
  }
  function accept(data) {
    if (data.schemaVersion !== 1 || !Array.isArray(data.campaigns)) throw new Error('Offers unavailable');
    const next = new Map();
    data.campaigns.filter(o => o.active && o.percentage > 0 && o.percentage < 100).forEach(offer => {
      offer.productIds?.forEach(id => {
        const key = String(id).split('/').pop();
        if (!next.has(key) || next.get(key).percentage < offer.percentage) next.set(key, offer);
      });
    });
    offers = next;
    loaded = true;
    lastRefresh = Date.now();
    render();
  }
  async function refresh() {
    try {
      const data = await window.NiralaDiscountData.read();
      accept(data);
    } catch (_) { offers.clear(); loaded = true; render(); }
  }
  document.addEventListener('nirala:product-updated', event => {
    const section = event.target.closest?.('[data-product-section][data-product-id]');
    if (section) queueLocalRender(section);
    else document.querySelectorAll('[data-product-section][data-product-id]').forEach(section => queueLocalRender(section));
  });
  document.addEventListener('nirala:discounts-payload', event => {
    try { accept(event.detail); } catch (_) { /* Ignore malformed storefront data. */ }
  });
  document.addEventListener('nirala:quick-order-updated', () => {
    queueLocalRender(null, true);
    if (Date.now() - lastRefresh > 30000) { lastRefresh = Date.now(); void refresh(); }
  });
  document.addEventListener('shopify:section:load', () => { refresh(); });
  const start = () => { render(); void refresh(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) render(); });
  window.setInterval(() => { if (!document.hidden) render(); }, 15000);
  window.setInterval(() => { if (!document.hidden) refresh(); }, 60000);
})();
